import { useState, useEffect, useCallback } from 'react'
import { api } from '../services'

interface BatteryStates {
  [deviceId: string]: boolean
}

export function useDeviceBatteryStates(): { lowBatteryDevices: BatteryStates } {
  const [lowBatteryDevices, setLowBatteryDevices] = useState<BatteryStates>({})

  const fetchStates = useCallback(async () => {
    try {
      const response = await api.getDeviceAlertStates()
      const states: BatteryStates = {}
      if (response?.data) {
        for (const state of response.data) {
          if (
            (state.conditionType === 'BATTERY_LOW' || state.conditionType === 'BATTERY_NO_POWER') &&
            state.isActive
          ) {
            states[String(state.deviceId)] = true
          }
        }
      }
      setLowBatteryDevices(states)
    } catch {
      // Silently fail - battery indicators are enhancement only
    }
  }, [])

  useEffect(() => {
    fetchStates()
    const interval = setInterval(fetchStates, 120000)
    return () => clearInterval(interval)
  }, [fetchStates])

  return { lowBatteryDevices }
}
